import NotifyMessage    from "../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyType       from "../../../domain/fundamentals/message/notify/NotifyType";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  NOTIFY_INIT = "NOTIFY_INIT",
  NOTIFY_SAVE_SUCCESS = "NOTIFY_SAVE_SUCCESS",
  NOTIFY_SAVE_FAILURE = "NOTIFY_SAVE_FAILURE",
  NOTIFY_DELETE_SUCCESS = "NOTIFY_DELETE_SUCCESS",
  NOTIFY_DELETE_FAILURE = "NOTIFY_DELETE_FAILURE",
  NOTIFY_FETCH_FAILURE = "NOTIFY_FETCH_FAILURE",
  NOTIFY_MAIL_SEND_SUCCESS = "NOTIFY_MAIL_SEND_SUCCESS",
  NOTIFY_OPTIONAL_MESSAGE = "NOTIFY_OPTIONAL_MESSAGE",
}

export interface NotifyBasicAction extends ResKaReduxAction {
}

export interface NotifyOptionalAction extends ResKaReduxAction {
  notifyType: NotifyType;
  notifyMessage: NotifyMessage;
}

export type NotifyAction = NotifyBasicAction | NotifyOptionalAction;

export const notifyInit = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_INIT
});
export const notifySaveSuccess = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_SAVE_SUCCESS
});

export const notifySaveFailure = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_SAVE_FAILURE
});

export const notifyDeleteSuccess = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_DELETE_SUCCESS
});

export const notifyDeleteFailure = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_DELETE_FAILURE
});

export const notifyFetchFailure = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_FETCH_FAILURE
});

export const notifyMailSendSuccess = (): NotifyBasicAction => ({
  type: ACTION_TYPE.NOTIFY_MAIL_SEND_SUCCESS,
});

export const notifyOptionalMessage = (notifyType: NotifyType, notifyMessage: NotifyMessage): NotifyOptionalAction => ({
  type: ACTION_TYPE.NOTIFY_OPTIONAL_MESSAGE,
  notifyType: notifyType,
  notifyMessage: notifyMessage,
});